<template>
  <section>
    <header class="header">
      <div class="container-fluid">
        <nav class="nav">
          <div class="nav-left header--left">
            <a href="#" class="nav-item">Worklogs</a>
          </div>

          <div class="nav-right nav-menu is-active header--right">
            <div v-if="kuzcosignedin">
              <router-link to="/dashboard" class="nav-item dashboard-button" >Go to Dashboard</router-link>
              <a class="nav-item dashboard-button" @click="signOut">Sign out</a>
            </div>
            <a class="nav-item" href='https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackauth&state=2a745b37' v-else>
            <img class="signintoslack-btn" src="../assets/img/signinwithslack.svg">
            </a>
            </a>
          </div>
        </nav>
      </div>
    </header>

    <section class="banner container-fluid">
      <div class="banner--content">
        <h2 class="m-b-md h2">Remote time tracking made convenient.</h2>
        <h4 class="m-b-lg h4">Worklogs is an app that allows you to track the number of working hours for remote teams right in Slack.</h4>
        <a href='http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,users.profile:write,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackadd&state=2a745b37'>
          <img class="addtoslack-btn" src="../assets/img/addtoslack.svg">
        </a>
        </a>
      </div>
    </section>

    <section class="intro">
      <div class="container">
        <div class="inner">
            <div class="intro--top">
              <img src="../assets/img/Art.png">
            </div>
        </div>
        <div class="intro--bottom">
          <p class="p">Worklogs is a bullshit-free time tracking app that works with your team’s Slack HQ.</p>
          <p class="p">It enables you to notify your team members when you’re available to work and what you’re working on.</p>
        </div>
      </div>
    </section>

    <section class="get-started">
      <div class="container">
        <div class="gs--top">
          <h3 class="h3">Get started in three simple steps</h3>
        </div>
        <div class="columns is-desktop gs--bottom">
          <div class="column">
            <div class="gs-one">
              <div class="gs-one-icon">
                <img class="image gs-image" src="../assets/img/1.png">
              </div>
              <div class="gs-one-text">
                <p>Owner/Admin of Slack Team creates a channel dedicated for Worklogs and adds Worklogs to their Slack.</p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="gs-two">
              <div class="gs-two-icon">
                <img class="image gs-image" src="../assets/img/2.png">
              </div>
              <div class="gs-two-text">
                <p>Members of Slack Team sign in to Worklogs.co to access Dashboard.</p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="gs-three">
              <div class="gs-three-icon">
                <img class="image gs-image" src="../assets/img/3.png">
              </div>
              <div class="gs-three-text">
                <p>Members can sign in and sign out to indicate working hours.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="features" id="features">
      <div class="container">
        <div class="features--top">
          <h3 class="h3">Features</h3>
        </div>
        <div class="features--middle">

          <div class="easy-signin columns">
            <div class="column left">
              <div class="signin-text">
                <div class="wrapper-md">
                  <h4>One Click Sign In</h4>
                  <p>One click sign in means you can get to work immediately. Add a reason for signing or be lazy and choose from past reasons.😎</p>
                </div>
              </div>
            </div>
            <div class="column right">
              <img class="image" src="../assets/img/signin.gif">
            </div>
          </div>

          <div class="k-notification columns">
            <!--displays on mobile only-->
            <div class="column right is-hidden-desktop">
              <div class="notification-text">
                <div class="wrapper-md">
                  <h4>Notifications</h4>
                  <p>Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏</p>
                </div>
              </div>
            </div>
            <div class="column left">
              <img class="image" src="../assets/img/notification.png">
            </div>
            <div class="column right is-hidden-mobile">
              <div class="notification-text">
                <div class="wrapper-md">
                  <h4>Notifications</h4>
                  <p>Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏</p>
                </div>
              </div>
            </div>
          </div>

          <div class="activity columns">
            <div class="column left">
              <div class="activity-text">
                <div class="wrapper-md">
                  <h4>Your Activity</h4>
                  <p>Detailed summary on time signed in and out with reasons and filterable date by time period.🤘🏿</p>
                </div>
              </div>
            </div>
            <div class="column right">
              <img class="image" src="../assets/img/newactivity.png">
            </div>
          </div>

          <div class="k-notification columns">
            <!--displays on mobile only-->
            <div class="column right is-hidden-desktop">
              <div class="notification-text">
                <div class="wrapper-md">
                  <h4>Your Reports</h4>
                  <p>Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈</p>
                </div>
              </div>
            </div>
            <div class="column left">
              <img class="image" src="../assets/img/newreports.png">
            </div>
            <div class="column right is-hidden-mobile">
              <div class="notification-text">
                <div class="wrapper-md">
                  <h4>Your Reports</h4>
                  <p>Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈</p>
                </div>
              </div>
            </div>
          </div>

          <div class="activity columns">
            <div class="column left">
              <div class="activity-text">
                <div class="wrapper-md">
                  <h4>New: Slash Commands</h4>
                  <p>Sign in and sign out can be done right in the Slack app like this <code>/worklogs sign in [with optional reason] [or sign out] [or status]</code>. Now, you can decide to only use the Worklogs web app when you need to see reports.🔥</p>
                </div>
              </div>
            </div>
            <div class="column right slash">
              <img class="image" src="../assets/img/slashcommands.gif">
            </div>
          </div>

          <div class="cta columns">
            <div class="cta-button">
              <a href="http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackadd&state=2a745b37">Add Worklogs to your Slack!✌🏿</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns is-tablet">
          <div class="column"><p class="copyright">Worklogs. Copyright 2017.</p></div>
          <div class="column">
            <p class="madeby">Made by <a href="https://twitter.com/olayinkaos">Olayinka Omole</a> and <a href="https://twitter.com/yomieluwande">Yomi Eluwande</a></p>
          </div>
        </div>
        <div class="columns is-tablet">
          <div class="column">
            <div class="follow">
              <a class="twitter-follow-button"
                 href="https://twitter.com/useworklogs"
                 data-size="large">
                Follow @Useworklogs</a>
            </div>
          </div>
          <div class="column">
            <div class="share">
              <p class="m-t-xs m-r-sm">Share on </p>
              <a target="_blank"
                 class="twitter-share-button m-r-md"
                 data-size="large"
                 href="https://twitter.com/intent/tweet?text=Check%20out%20Worklogs.%20A%20tool%20that%20helps%20track%20working%20hours%20for%20members%20in%20remote%20teams.&url=https://worklogs.co&via=useworklogs"
              >Twitter</a>
              <!--<a target="_blank"-->
              <!--href="http://www.facebook.com/sharer.php?u=https://worklogs.co"-->
              <!--&gt;Facebook</a>-->
              <div class="fb-share-button" data-href="https://worklogs.co" data-layout="button_count" data-size="large" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fworklogs.co%2F&amp;src=sdkpreparse">Share</a></div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
  import { store } from '../store/store';
  export default {
    name: 'Home',
    data () {
        return {
          kuzcosignedin: false
        }
    },
    watch: {
      '$route': 'fetchData'
    },
    created: function() {
      this.fetchData()
    },
    methods: {
        fetchData: function () {
          let self = this;
          if(localStorage.firstload == 'true') {
            localStorage.firstload = false;
            window.location.reload();
          }
          else {
            //do nothing
          }

          if (localStorage.globalsignin) {
            self.kuzcosignedin = true
          }
          else {
            self.kuzcosignedin = false
          }
        },
        signOut: function () {
          localStorage.clear()
          window.location.reload();
        }
    }

  }

</script>

<style scoped lang="scss" type="text/scss">
  $mobile: 768px;
  $tablet: 769px;
  $desktop: 1000px;
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;

  .fb_iframe_widget {
    margin-left: 10px;
  }

  .fb_iframe_widget iframe {
    margin-left: 10px;
  }

  body {
    font-family: "Montserrat Regular";
    background-color: white;
    color: #3E454F;
    line-height: 30px;
  }
  .nav {
    background-color: transparent;
  }
  .nav-toggle {
    &:hover {
      background-color: transparent;
    }
    span {
      background-color: white;
    }
  }
  .dashboard-button {
    border: 1px solid;
    border-radius: 3px;
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    color: white;
    z-index: 9;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
    padding-bottom: 20px;
    a {
      color: white;
    }
  }
  .header--left {
    a {
      font-family: "Montserrat SemiBold";
      font-size: 18px;
    }
  }
  .header--right {
    font-family: "Montserrat SemiBold";
    text-align: right;
    @media (max-width: 480px) {
      background-color: transparent;
      box-shadow: none;
      border: none;
    }
    a {
      font-size: 15px;
      display: inline-block;
      margin-right: 10px;
    }
    .signintoslack-btn {
      width: 150px;
      max-height: 100%;
    }
    .features-link {
      @media (min-width: 1000px) {
        margin-right: 30px;
      }
    }
  }
  .banner {
    background-color: $oldthemecolor;
    background: linear-gradient(rgba(62,69,70,.8),rgba(62,69,70,.8)),url('/static/kuzcobanner.jpg') no-repeat 50%;
    background-size: cover;
    height: 600px;
    color: white;
      .banner--content {
        padding: 104px 80px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 100%;
        max-width: 1120px;
        margin: 0 auto;
        position: relative;
        height: 100%;
        @media (max-width: 480px) {
          padding: 104px 10px;
        }
        h2 {
          font-family: "HUGE Avant Garde";
          font-size: 3rem;
          letter-spacing: 1px;
          @media (max-width: 480px) {
            font-size: 2.5rem;
          }
        }
        h4 {
          font-family: "Montserrat Regular";
          font-size: 1.5rem;
          color: #EAE9E9;
          @media (max-width: 480px) {
            font-size: 1.2rem;
          }
        }
        .addtoslack-btn {
          width: 180px;
        }
      }
  }
  .intro {
    background-color: #FAFBFC;
    padding-bottom: 50px;
    border-bottom: 1px solid #D7E2E9;
      .inner {
        position: absolute;
        width: 100%;
      }
      .intro--top {
        img {
          width: 70%;
          margin-left: auto;
          margin-right: auto;
          display: table;
          margin-top: -80px;
          @media (max-width: 480px) {
            width: 90%;
          }
        }
      }
      .intro--bottom {
        padding-top: 40%;
        p {
          font-size: 1.4rem;
          color: #404247;
          font-family: "Montserrat Regular";
          line-height: 20px;
          text-align: center;
          @media (max-width: 480px) {
            font-size: 1rem;
          }
        }
      }
  }
  .get-started {
    border-bottom: 1px solid #D7E2E9;
    padding: 100px 20px;
    .gs--top {
      text-align: center;
      margin-bottom: 50px;
      h3 {
        font-family: "HUGE Avant Garde";
        font-size: 3.2rem;
        letter-spacing: 1px;
      }
    }
    .gs-one, .gs-two, .gs-three {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      width: 100%;
      padding: 10px;
    }
    .gs-image {
      @media (max-width: $tablet) {
        width: 60px;
      }
      @media (min-width: $tablet ) and (max-width: $desktop) {
        width: 60px;
      }
    }
    .gs-one-icon, .gs-two-icon, .gs-three-icon {
      margin-right: 10px;
    }
    .gs-one-text, .gs-two-text, .gs-three-text {
      display: flex;
      align-items: center;
      p {
        font-size: 14px;
        line-height: 24px;

      }
    }

  }
  .features {
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: 1px solid #D7E2E9;
    background-image: url('/static/bg-pattern.png');
    .features--top {
      text-align: center;
      h3 {
        font-family: "HUGE Avant Garde";
        font-size: 3.2rem;
        letter-spacing: 1px;
      }
    }
    .features--middle {
      .easy-signin {
        margin-top: 40px;
        .left, .right {
          height: 400px;
        }
        .left {
          @media (max-width: 480px) {
            height: auto;
          }
          .signin-text {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }
          h4 {
            text-align: left;
            font-size: 30px;
            font-family: "Huge Avant Garde";
          }
          p {
            font-size: 15px;
            font-family: "Montserrat Semibold";
          }
        }
        .right {
          background-color: #eee;
          img {
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .k-notification {
        margin-top: 60px;
        .left, .right {
          height: 400px;
        }
        .right {
          @media (max-width: 480px) {
            height: auto;
          }
          .notification-text {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }
          h4 {
            text-align: left;
            font-size: 30px;
            font-family: "Huge Avant Garde";
          }
          p {
            font-size: 15px;
            font-family: "Montserrat Semibold";
          }
        }
        .left {
          @media (max-width: 480px) {
            height: auto;
          }
        }
      }
      .activity {
        margin-top: 40px;
        .left, .right {
          height: 400px;
        }
        .left {
          @media (max-width: 480px) {
            height: auto;
          }
          .activity-text {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }
          h4 {
            text-align: left;
            font-size: 30px;
            font-family: "Huge Avant Garde";
          }
          p {
            font-size: 15px;
            font-family: "Montserrat Semibold";
          }
        }
        .slash {
          background-color: #eee;
          img {
            height: 100%;
            -o-object-fit: contain;
            object-fit: contain;
            width: 100%;
          }
        }
        .right {
          @media (max-width: 480px) {
            height: auto;
          }
        }
      }
      .cta {
        margin-top: 90px;
        .cta-button {
          width: 270px;
          margin: 0 auto;
          a {
            background-color: white;
            padding: 15px 20px;
            border: 1px solid $oldthemecolor;
            border-radius: 4px;
            font-size: 15px;
          }
        }
      }
    }
    .features-text-header {
      font-size: 20px;
      font-family: "Huge Avant Garde";
      margin-bottom: 20px;
    }
    .features-text {
      font-size: 15px;
      line-height: 24px;
    }
  }
  .footer {
    padding: 40px 20px;
    background-color: #FAFBFC;
    p {
      font-size: 13px;
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    .copyright {
      text-align: left;
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    .follow {
      text-align: left;
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    .madeby {
      text-align: right;
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    .share {
      text-align: right;
      display: flex;
      float: right;
      iframe {
        margin-right: 15px;
      }
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    a {
      color: $kuzcogreen;
      @media (max-width: 480px) {
        text-align: center;
      }
    }
    .fa {
      margin-top: 3px;
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?370bb261